var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "AttachURL" }, [
    _c("div", { staticClass: "AttachURL__block" }, [
      _c("div", { staticClass: "AttachURL__head" }, [
        _vm._v("\n            Attach URL Link\n            "),
        _c(
          "button",
          {
            staticClass: "btn__reset",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("i", { staticClass: "icon-close" })]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "AttachURL__body" }, [
        _vm.attachURLImage
          ? _c("img", { attrs: { src: _vm.attachURLImage } })
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.attachURL,
              expression: "attachURL"
            }
          ],
          staticClass: "full__width",
          attrs: { type: "text", placeholder: _vm.$t("PLACEHOLDER.ADD_URL") },
          domProps: { value: _vm.attachURL },
          on: {
            blur: _vm.getInfoFromUrl,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.attachURL = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "AttachURL__footer text__right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn__m btn__round btn__bordered",
            attrs: { disabled: _vm.attachURLDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.handleAddLink($event)
              }
            }
          },
          [
            _vm._v("\n                Add\n                "),
            _vm.parsingProgress
              ? _c("div", { staticClass: "spinner-border" })
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }